import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4fada3fb&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=4fada3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fada3fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fada3fb')) {
      api.createRecord('4fada3fb', component.options)
    } else {
      api.reload('4fada3fb', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=4fada3fb&scoped=true&", function () {
      api.rerender('4fada3fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jf0HVIODpNA7/JS/comp/Voucher.vue"
export default component.exports